<template>
  <transition name="slide">
    <div v-show="isshow" class="share-indicator" @click.stop.prevent="$emit('on-touchmove')">
      <div class="share-mask"></div>
      <div class="share-content">
        <img class="arrow" src="../../image/global/share-arrow.png" alt="">
        <div class="share-main">
          <img class="people" src="../../image/global/share-people.png" alt="">
          <div class="tip">{{text}}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import spinner from './spinner.vue'

  export default {
    name: 'mp-share-indicator',
    props: {
      text: {
        type: String,
        default: "点击右上角分享给好友吧..."
      },
      isshow: {
        type: Boolean,
      }
    },
    data() {
      return {
      }
    },
    components: {
      spinner,
    }
  }
</script>

<style lang="less">
  .share-indicator {
    z-index: 301;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .share-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgb(0, 0, 0);
      opacity: 0.6;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .share-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .arrow {
        position: absolute;
        top: 20px;
        right: 24.5px;
      }
      .share-main {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .people {
          z-index: 2;
        }
        .tip {
          z-index: 2;
          color: #fff;
        }
      }
    }
  }
</style>

